var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudiobook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.43,
    y: 236.85,
    width: 42.9,
    height: 270.93,
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.43,
    y: 245.39,
    width: 42.9,
    height: 11.16,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.43,
    y: 489.87,
    width: 42.9,
    height: 11.16,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.78 229.72 475.08 229.72 382.81 501.78 349.55 501.78 441.78 229.72",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.41 508.05 344.61 506.8 442.38 222.71 446.18 223.95 348.41 508.05",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.41 511.05 378.61 509.8 476.38 225.71 480.18 226.95 382.41 511.05",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.11 304.76 346.11 330.76 375.11 329.76 373.23 295.86 350.11 304.76",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.61,
    y: 255.26,
    width: 37,
    height: 54,
    rx: 18.5,
    ry: 18.5,
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 375.85,
    cy: 253.56,
    r: 10.26,
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.35,
    cy: 259.35,
    r: 7.9,
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.52,309.63c-1.22,2.35-3.72,3.77-6.36,3.71-6.53-.16-10.15-4.41-10.15-4.41-6.39,1.59-10.21,.43-10.21,.43,9.61-10.32,3.38-19.76,3.38-19.76-8.92-5.92-7.87-12.62-7.87-12.62-8.78-1.38-13.3-4.4-15.37-6.33-.41-.38-.93-.57-1.44-.57-.62,0-1.23,.27-1.65,.79-.15,.19-.28,.42-.36,.66-.8,2.38-1.06,2.85-2.37,5.23l-1.62,2.95c-2.66-6.59-.22-21.78,8.35-25.52,1.47-.64,2.98-1.11,4.45-1.44,2.47-.55,4.87-.72,6.94-.7,3.84,.03,6.55,.67,6.55,.67,20.75,1.64,27.3,37.65,27.3,37.65,3.1,10.32,2.06,16.11,.43,19.26Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,449.64l59.91-66.68s11.16-14.51,29.2-13.65l-50.89,82-38.22-1.67Z",
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.59,461.95l-2.89,4.11s2.13-.61,6.86,3.05c0,0,3.8,3.35,16.91,0l9.44-2.63,2.17-4.07-32.49-.46Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,469.62l-4.1,6.14s-3.32-2-7.34,2.64c-1.75,1.85-3.83,3.35-6.14,4.42,0,0-15,6.73-30,9.47,0,0-6.17-1.16-9,3.33-.83,1.42-1.3,3.03-1.34,4.68,0,0-26.86,.27-28.48-4.58-.61-1.89-.76-3.9-.43-5.86,.63-3.21,3.09-6.56,10.61-6.71,1.44-.04,2.87-.23,4.26-.59,7.91-1.89,15.67-4.33,23.24-7.3,3.67-1.56,7.02-3.8,9.87-6.59,1.23-1.3,2.82-2.2,4.56-2.6,0,0,3.14-.54,6.85,3,0,0,3.41,3.05,16.21,.16l.71-.16c5.85-1.63,8.32-2.29,9.44-2.63-.58,1.18-.09,2.6,1.08,3.18Z",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,451.34l-46-2s-4.83-.71-6.19,3.61l-3.63,6.81s-1.82,3.4,3.63,3.63l48.19,1.39s3.86,.91,5.45-2.27l4.31-5.4s2.4-6.7-5.76-5.77Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81,468.42l-4.89,7.34c1.73,.51,3.38,1.27,4.89,2.26,0,0,5.65,3,16.76,0,0,0,9.39-3.46,14.07-4.13l1.27-2.92-5.95-8-26.15,5.45Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,507.95l-55,.88s-33.3,2.72-32.4-5.92c-.2-1.33-.2-2.67,0-4,.52-3.19,2.33-7.23,9.07-6.76,.8,.05,1.61,0,2.4-.14,9.87-2.09,19.5-5.18,28.74-9.22,2.34-1.01,4.44-2.52,6.14-4.42,1.73-1.91,4.44-4,7.34-2.64,0,0,1.6,.22,4.89,2.26,0,0,6.87,3.2,16.75,0,0,0,10.48-3.82,14.08-4.13,0,0,1.63,1.49,1.27,8-.28,2.32-.42,4.66-.43,7-.01,1.93,.15,3.86,.48,5.76,0,0,7.44,11.55-3.33,13.33Z",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.55,354.65h0c.36,1.99,1.33,3.81,2.79,5.21,2.99,2.8,6.57,4.89,10.48,6.11,0,0,26.48,5.62,32.65,9.87,0,0,3.46,5.72,2.32,12,0,0-32.18-12.28-42.07-13.77-.6-.09-1.19-.21-1.77-.37-3.69-1-15.19-4.46-17.75-11l13.35-8.05Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.89,272.79c-2.44-1.23-5.33-1.23-7.78,0-1.87-7-5.35-14.51-7-17.03l-1.81-3.01c2.47-.55,4.87-.72,6.94-.7,4.08,7.88,9.65,20.74,9.65,20.74Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.77,447.17l-40.72-14.3-14.05-41.3c1.79-5.21,1.26-10.94-1.48-15.73-5.33-6.48-3.72-15.15-2.73-18.73,.3-1.05,.73-2.06,1.3-3,3.94-6.42,13.27-12.89,21.48-17.7,.74-.43,1.45-.85,2.17-1.25,7-4,12.7-6.51,12.7-6.51,1.85,1.02,4.15,.72,5.67-.75,0,0,8.8-8.95,18.81-8.2,0,0,8.55,.11,13.51,7.4,.14,.21,.29,.42,.45,.62,2.73,3.5,4.41,7.71,4.36,12.15-.5,44.04-21.47,107.3-21.47,107.3Z",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85,377.61l-7.32,11.75s-32.67-13.77-46.43-15.39c0,0-16.2-4-18.9-11.33l-41.2-29.79s1.08,16.92,7.74,24.12c0,0-3.6,10.62,17.81,22.31,0,0,17.82,14.94,36.18,25.2,0,0,35.09,23.57,47.68,27.53,0,0,12.78,5.94,22.68-10.26l23.57-40.22-41.81-3.92Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.74,324.78l39.62,43.42,26.85-16.39c.25-.15,.25-.51,.01-.67l-1.64-1.07-46.61-30.46-17.51,1.9-.72,3.27Z",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6,318.74l38.87,41.83,11.27-6.99v5.02l-12.17,7.37-39.45-43.2,1.17-3.95c.04-.14,.22-.18,.32-.07Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,317.02l-17.19,1.47c-.05,0-.08,.07-.04,.1l39,41.98,11.27-6.99-33.04-36.56Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.36,353.34l12.03-7.23c.08-.05,.19,.01,.19,.11v3.85l-12.22,8.25v-4.98Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.11 316.76 235.28 310.72 268.58 345.99 255.11 353.76 223.11 316.76",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.24 328 228.5 314.74 232.46 312.39 244 325.74 240.57 324.66 240.24 328",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.84,342.88s-.78-10.58,3.22-9.16c0,0,6.19,4.26,5.81,19.61",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.54,433.07l69.46,53.16,12.49,9.53s8.77,7,18.75,9.9l-24.88-53.71-72-38.59-3.82,19.71Z",
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.57,
    y: 224.21,
    width: 71.74,
    height: 284.62,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.25,
    y: 218.54,
    width: 12.39,
    height: 289.23,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.63,
    y: 209.78,
    width: 44.34,
    height: 297.99,
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.97,
    y: 234.61,
    width: 58.56,
    height: 273.16,
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.97,
    y: 253.39,
    width: 58.56,
    height: 16.47,
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.97,
    y: 473.4,
    width: 58.56,
    height: 16.47,
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.97,
    y: 463.69,
    width: 58.56,
    height: 6.26,
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.22,
    y: 224.21,
    width: 35.15,
    height: 283.56,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.07,394.63h11.12c3.78,0,6.84,3.06,6.84,6.84h0c0,3.78-3.06,6.84-6.84,6.84h-11.12v-13.68h0Z",
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54,289.56s-.52,17.37-17.15,39.05",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.85,459.74l24.57-30.69c.88-1.1,2.48-1.3,3.6-.44,7.97,6.08,37.99,29.41,63.03,54.32,2.21,2.22,4.3,4.56,6.27,7,5.91,7.29,23.94,25.84,48.18,16.21,0,0,27.94-11.19,31.39-61.06l-34.84-12.2s-3.9,2-17.49-5.8c0,0-26-16-36.84-22.59,0,0-28-17.13-36.18-25.2,0,0-9.4-5.67-14.21-11.08,0,0-23.26-10.68-33.27,4.33l-55.33,83.53,44.53,2.37s5.27-1.06,6.59,1.31Z",
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.99,458.21c-.73,.05-1.47,.03-2.2,0l-44.05-2.15s-4.83-.71-6.19,3.61l-3.63,6.81s-1.82,3.4,3.63,3.63l48.13,2.36s3.85-.09,5.44-3.27l3.48-4.36c.89-1.06,1.23-2.48,.91-3.83-.39-1.52-1.71-3.05-5.51-2.8Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.63,
    y: 221.28,
    width: 5.87,
    height: 290.27,
    rx: 2.93,
    ry: 2.93,
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.38,
    y: 221.28,
    width: 5.87,
    height: 290.27,
    rx: 2.93,
    ry: 2.93,
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765,401.46s60-9.72,62.68-86.63c.69-22.14-3.58-44.16-12.48-64.44-18.48-42.6-65.52-117.31-160.81-87.78,0,0-54.46,9.66-99.29,45-5.1,4.06-9.88,8.51-14.27,13.33-9.92,10.76-30.41,33.15-36.17,40.64,0,0-42.17,51.83-94.1,29.29,0,0-20.41-10.73-20-28.43,.15-12.11,10.08-21.8,22.18-21.65,2.54,.03,5.05,.5,7.43,1.39,9.71,3.63,21.36,14.26,32.53,40.2,0,0,21.56,42.6,13.39,89.89,0,0-5.65,44.5-45,66.78-17.59,10-38.58,12.47-57.72,5.94-9.07-3.09-18.39-8.36-25-17.29",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706.53,
    y: 220.2,
    width: 5.39,
    height: 291.35,
    rx: 2.69,
    ry: 2.69,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.68,
    y: 220.85,
    width: 5.39,
    height: 291.35,
    rx: 2.69,
    ry: 2.69,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.63,235.24v30.68c0,.28,.3,.45,.54,.32l16.24-9.05v-13.21l-16.24-9.05c-.24-.13-.54,.04-.54,.32Z",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.41,244.21h2.07c3.49,0,6.32,2.83,6.32,6.32h0c0,3.49-2.83,6.32-6.32,6.32h-2.07v-12.64Z",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 280.73,
    r: 8.83,
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 280.73,
    r: 5.73,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.85,331.22l-8.58,51.56c-.09,.55-.6,.92-1.15,.85l-43.28-5.96c-.69-.09-1.08-.83-.79-1.45l22.34-47.61s6.72-13.84,18.72-13.84c0,0,.1,0,.27,.02,8.26,.57,14.1,8.33,12.47,16.44Z",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,356.26s6,5,9,13",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.53,
    y1: 389.36,
    x2: 334.61,
    y2: 395.26,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 603.61,
    y1: 224.26,
    x2: 647.89,
    y2: 224.26,
    fill: "none",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 603.61,
    y1: 230.26,
    x2: 647.89,
    y2: 230.26,
    fill: "none",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 603.61,
    y1: 243.26,
    x2: 647.89,
    y2: 243.26,
    fill: "none",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.89,
    y1: 494.26,
    x2: 603.61,
    y2: 494.26,
    fill: "none",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.89,
    y1: 488.26,
    x2: 603.61,
    y2: 488.26,
    fill: "none",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.89,
    y1: 475.26,
    x2: 603.61,
    y2: 475.26,
    fill: "none",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.11,
    y: 289.76,
    width: 6,
    height: 153,
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.11,
    y: 289.76,
    width: 6,
    height: 153,
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.9,236.97s-13.64,13.21-.22,27.21",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,239.55s-11.87,10.46-.38,22.07",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.67,243.03s-8.75,6.9-.15,15.09",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.11,
    cy: 170.76,
    r: 22.5,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.86,162.13v17.23c0,.51,.56,.82,.99,.56l14.57-8.82c.43-.26,.42-.88-.01-1.13l-14.57-8.41c-.44-.25-.98,.06-.98,.57Z",
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.11,
    cy: 330.76,
    r: 17.5,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.02,324.05v13.4c0,.4,.43,.64,.77,.44l11.33-6.86c.33-.2,.33-.68,0-.88l-11.33-6.54c-.34-.2-.76,.05-.76,.44Z",
    fill: "#383838",
    stroke: "#002346",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M527.96,455.53c.2,2.34,.51,4.98,.96,7.67,0,0,9.48-31.02,40.64-27.02l-6.12-13.48-5.06-5.06c-10.16,5.28-20,3.69-26.72,17.32-3.14,6.36-4.31,13.51-3.69,20.58Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.81,425.83c-28.12,.03-32.32-41.41-3.91-75.9,.09-.11,.27-.04,.26,.11-1.12,11.76,33.4,53.9,10.78,73.19-1.99,1.69-4.51,2.6-7.12,2.6Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.12,410.35c-17.74-10.53-13.74-42.1,38.83-60.73,.1-.03,.2,.06,.16,.15-.6,1.71-4.08,12.88-5.91,44.4-.49,8.4-12.49,28.4-33.08,16.17Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.47,479.54c.8,6.21-41.3,6.21-40.5,0-.8-6.21,41.3-6.21,40.5,0Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.14,534.54c-1.82-.27-48.18,.79-48.29-.86-9.13-4.33-9.52-18.47-9.52-18.47-1.38-18.87,15.65-28.99,15.65-28.99v-6.67c-.8,6.21,41.3,6.21,40.5,0v7.13c22.29,14.63,17.77,46.38,1.66,47.86Z",
    fill: "#f6c074",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.85,494.96c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.14,503.24c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.52,516.59c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.15,526.71c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.6,529.48c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.11,526.71c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.45,518.89c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.83,503.24c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.96,494.04c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.16,502.32c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.57,509.68c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.78,518.89c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.9,511.07c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.75,495.42c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.03,505.08c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.47,511.53c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.27,520.73c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.33,448.47c-15.18-12.36-36.76,4.61-15.19,25.77,0,0,11.05,10.12,15.65,20.71,0,0,21.17-15.19,21.63-35.9,0,0,0-21.17-22.09-10.59Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.48,445.91c23.85-42.04,34.03,1.19,69.93-4.8,.54-48.33-69.4-46.3-69.93,4.8Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.97,486.21s16.99,8.72,40.5,.46",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.48,463.91s10-42,35.45-21.63c3.58,2.86,5.82,7.08,6.91,11.53,1.69,6.9,3.83,19.46,1.14,31.6",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.98,353.41s-47,34-31,126",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.98,418.41s62-1,64,60",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiobook);
export default __webpack_public_path__ + "static/media/Audiobook.5bd93804942b56019fb7210d4f07cdcc.svg";
export { ForwardRef as ReactComponent };